module.exports = __webpack_public_path__ + "img/precious_plastic_bazar.3bca6538.jpg";